import axios from "axios";

// import router from "@/router";
import requestUrl from "../config/api.js"; //import接口域名地址配置
import dataUrl from "../config/url.js";
import { cookie } from "@/common/js/public";
import AES from '@/common/js/AES.js'
const service = axios.create({
    baseURL: requestUrl.requestUrl,
    //timeout: 300000
});

service.dataUrl = dataUrl;

// request拦截cookie.get("token")
service.interceptors.request.use(
    config => {
        requestUrl.loading = true
        if (window.sessionStorage.getItem('token')) {
            config.headers["userLoginId"] = window.sessionStorage.getItem('token');
        }
        config.headers['client'] = "pc"
    

        if(config.url.indexOf("base/file/mgmt/addOneImage")=="-1"){
            config.headers["Content-Type"] = "application/json;charset=UTF-8";
            // config.data = AES.encrypt(config.data);
        }
        return config;
    },
    error => {
        console.log(error);
        $Message.error("请重新登陆");
        return Promise.reject(error);
    }
);

// respone拦截
service.interceptors.response.use(
    response => {
        try{
            if(response.headers['content-type'].indexOf("json")!="-1"){
                // response.data = JSON.parse(AES.decrypt(response.data));
            }
        }catch(e){
            
        }
        
        requestUrl.loading = false;
        const code = response.data.code;
        if (code == -501) {
            //   router.push("/login");
            window.location.hash = '#/login';
        } else {
            return response;
        }
    },
    error => {
        requestUrl.loading = false;
        console.log(error);
        $Message.error("请求超时");
        return Promise.reject(error);
    }
);

export default service;